var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgTick = function SvgTick(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 14,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#tick_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#56B83A",
    d: "M7.296 14a7 7 0 1 0 0-14 7 7 0 0 0 0 14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#438F2E",
    d: "m5.507 10.158 3.6 3.6A6.995 6.995 0 0 0 14.295 7v-.199l-2.827-2.605z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M11.072 3.688a.827.827 0 0 0-1.148 0L6.254 7.34 4.668 5.741a.827.827 0 0 0-1.148 0l-.64.64c-.31.31-.31.84 0 1.149l2.804 2.826c.309.31.839.31 1.148 0l.64-.64a1 1 0 0 0 .091-.11l4.15-4.13c.309-.309.309-.839 0-1.148z",
    clipRule: "evenodd"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "tick_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M.296 0h14v14h-14z"
  })))));
};
export default SvgTick;